import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_mentor_profile_data_action,
  update_user_meta_data_action,
  update_mentor_profile_action,
  create_mentor_action,
  get_mentor_all_skills_data_action,
  create_mentor_skills_data_action,
  delete_mentor_skill_by_id_data_action,
  update_mentor_skill_by_id_data_action,
  update_user_timezone_action,
} from "../../../redux/_actions";
import { useNavigate } from "react-router-dom";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function useSignup(props) {
  // state from redux
  const [user, setUser] = useState({});
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);
  const [searchKeywordString, setSearchKeywordString] = useState("");
  const [searchKeywordsSuggestions, setSearchKeywordsSuggestions] = useState([]);
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [isTimezoneMessageModal, setIsTimezoneMessageModal] = useState(true);
  

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // initial states
  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );
  const { userSkillsData } = useSelector(
    (state) => state.get_mentor_all_skills_data_reducer
  );
  const { newUserSkillData } = useSelector(
    (state) => state.create_mentor_skills_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (mentorProfileData?.data) {
      setUser(mentorProfileData?.data);
    }
  }, [mentorProfileData]);

  useEffect(() => {
    if (userSkillsData?.data) {
      let data = userSkillsData?.data;
      setSkillsTagsAdded(data);
    }
  }, [userSkillsData]);

  useEffect(() => {
    if (newUserSkillData?.data) {
      let skills = skillsTagsAdded;
      skills.push(newUserSkillData?.data);
      setSkillsTagsAdded(skills);
    }
  }, [newUserSkillData]);

  const callApi = async () => {
    await dispatch(get_mentor_all_skills_data_action());
    await dispatch(get_mentor_profile_data_action());
    setSkillsListLoading(false);
  };

  // delete skills tags
  const onKeywordsTagsDelete = async (tag) => {
    await dispatch(delete_mentor_skill_by_id_data_action(tag.id));
    let skills = skillsTagsAdded.filter((item) => item !== tag);
    setSkillsTagsAdded(skills);
  };

  // add new skills tags
  const onKeywordsTagsAddition = async (tag) => {
    let primarySkills =
      skillsTagsAdded &&
      skillsTagsAdded.filter((item) => item?.is_primary === true);
    let data = {
      skill: tag,
      is_primary: true,
      rating: 1,
    };
    if (primarySkills && primarySkills.length >= 5) {
      data["is_primary"] = false;
    }
    await dispatch(create_mentor_skills_data_action(data));
    setSearchKeywordsSuggestions([]);
    setSearchKeywordString();
  };

  //
  const onSkillChange = async (value, key, item) => {
    let data = item;
    data[key] = value;
    data["skill"] = item["skill_name"];

    if (key === "is_primary") {
      let primarySkills =
        skillsTagsAdded &&
        skillsTagsAdded.filter((item) => item?.is_primary === true);
      if (primarySkills && primarySkills.length > 5) {
        showWarningMessage("Can not add more than 5 primary skills");
        return;
      }
    }
    setSkillsListLoading(true);
    await dispatch(update_mentor_skill_by_id_data_action(item?.id, data));
    callApi();
  };

  const onImageResume = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        await dispatch(update_user_meta_data_action(data));
        await dispatch(get_mentor_profile_data_action());
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    }
  };

  const onInputBlur = async (e) => {
    let value = e.target.value;
    let key = e.target.name;

    if (value.length) {
      await dispatch(update_mentor_profile_action({ [key]: value }));
      await dispatch(get_mentor_profile_data_action());
    }
  };

  const contactNumberHandler = async (e) => {
    if (!phoneInput.length) {
      showWarningMessage("Phone number cannot be empty.");
      return;
    }
      await dispatch(create_mentor_action({ phone: phoneInput }));
      await dispatch(get_mentor_profile_data_action());
  };

  const onSubmitClick = () => {
    let parsedUser = JSON.parse(localStorage.getItem("jigsawUser"));
    parsedUser = { ...parsedUser, user: user?.user_details };
    localStorage.setItem("jigsawUser", JSON.stringify(parsedUser));
    if (!phoneInput) {
      showWarningMessage("Please Enter Phone Number.");
    }else if (!skillsTagsAdded || skillsTagsAdded.length === 0) {
      showWarningMessage("Please add at least one skill.");
      return;
    }else if (user?.user_details && user.user_details?.is_verified) {
      navigate("/dashboard");
    } else {
      navigate("/mentor-verification-pending");
    }
  };

  const onEditProfileClick = () => {
    navigate("/edit-mentor-profile");
  };

  const onTimeZoneChange = async (e) => {
    let value = e.target.value;
    let key = e.target.name;
    let data = {};
    data[key] = value;
    await dispatch(update_user_timezone_action(data));
    await dispatch(get_mentor_profile_data_action());
  };

  const onSignIn = () => {
    localStorage.removeItem("jigsawUser");
    navigate("/sign-in");
  };

  const onCloseTimezoneMessageModal = () => {
    setIsTimezoneMessageModal(false);
  };
  return {
    user,
    searchKeywordString,
    skillsListLoading,
    skillsTagsAdded,
    searchKeywordsSuggestions,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onSkillChange,
    onInputBlur,
    onImageResume,
    contactNumberHandler,
    onSubmitClick,
    onEditProfileClick,
    onTimeZoneChange,
    setPhoneInput,
    onSignIn,
    isTimezoneMessageModal,
    onCloseTimezoneMessageModal
  };
}
export default useSignup;

